export default {
    topics: [
        {
            title: ' Cancel ',
            href: 'sm-deliveryOperation-Cancel.html',
            attributes: { 'data-id': 'sm-deliveryOperation-Cancel' },
            menu: { hasChildren: false },
            tocID: 'sm-deliveryOperation-Cancel-d66e2828',
            topics: [],
        },
        {
            title: ' PrepareMessage ',
            href: 'sm-deliveryOperation-PrepareMessage.html',
            attributes: { 'data-id': 'sm-deliveryOperation-PrepareMessage' },
            menu: { hasChildren: false },
            tocID: 'sm-deliveryOperation-PrepareMessage-d66e2836',
            topics: [],
        },
    ],
};

